var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Web Version",
      prop: "webVersion"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Web Version"
    },
    model: {
      value: _vm.formData.webVersion,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "webVersion", $$v);
      },
      expression: "formData.webVersion"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Android Version",
      prop: "androidVersion"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Android Version"
    },
    model: {
      value: _vm.formData.androidVersion,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "androidVersion", $$v);
      },
      expression: "formData.androidVersion"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Android Force Update",
      prop: "androidForceUpdate"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.androidForceUpdate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "androidForceUpdate", $$v);
      },
      expression: "formData.androidForceUpdate"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "iOS Version",
      prop: "iosVersion"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "iOS Version"
    },
    model: {
      value: _vm.formData.iosVersion,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "iosVersion", $$v);
      },
      expression: "formData.iosVersion"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "iOS Force Update",
      prop: "iosForceUpdate"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.iosForceUpdate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "iosForceUpdate", $$v);
      },
      expression: "formData.iosForceUpdate"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "iOS Skip Version",
      prop: "iosSkipLoginVersion"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "iOS Skip Version"
    },
    model: {
      value: _vm.formData.iosSkipLoginVersion,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "iosSkipLoginVersion", $$v);
      },
      expression: "formData.iosSkipLoginVersion"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "iOS Skip Login",
      prop: "iosSkipLogin"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.iosSkipLogin,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "iosSkipLogin", $$v);
      },
      expression: "formData.iosSkipLogin"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "App Discount Label",
      prop: "appDiscountLabel"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "App Discount Label"
    },
    model: {
      value: _vm.formData.appDiscountLabel,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "appDiscountLabel", $$v);
      },
      expression: "formData.appDiscountLabel"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "iOS Skip Registration",
      prop: "iosSkipRegistration"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.iosSkipRegistration,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "iosSkipRegistration", $$v);
      },
      expression: "formData.iosSkipRegistration"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };